import { FC } from 'react';
import { AvailabilityType } from '../../module/types/availability';
import { ElementIdTab } from '@app/entities/Product';
import classNames from 'classnames';
import { quantityLimitation } from '@app/shared/helpers';
import { AvailableStringByCartProduct, AvailableStringProductRow, AvailableType } from '@app/entities/Delivery/module/types/deliveryTypes';
import { MyLink } from '@app/shared';
import { useWindowSizing } from '@app/hooks/useSizeWindow';

import styles from './AvailabilityRepresentation.module.scss';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';

interface AvailabilityRepresentationProps {
  availabilityNow: AvailabilityType;
  availabilityLater: AvailabilityType;
  allQuantity?: number;
  className?: string;
  url: string;
  short?: boolean;
  productId: number;
  part: number;
}

export const AvailabilityRepresentation: FC<AvailabilityRepresentationProps> = ({
  availabilityNow,
  availabilityLater,
  allQuantity,
  className,
  url,
  short,
  productId,
  part,
}) => {
  const isMobile = useWindowSizing(990);

  const onNavigate = async (e, url) => {
    e.preventDefault();

    await ServiceEcommerce2.selectItem([
      {
        id: productId,
        part,
      },
    ]);

    const target = e.ctrlKey ? '_blank' : '_top';
    window.open(url, target);
  };

  return (
    <div className={classNames(styles.WrapperRowAvailability, className)}>
      {!!availabilityNow?.quantity && (
        <MyLink reloaded href={'#'} onClick={e => onNavigate(e, `${url}#${ElementIdTab.TabAvailabilityFast}`)} className={styles.inStock}>
          {`${quantityLimitation(availabilityNow.quantity)} шт. ${AvailableStringProductRow[availabilityNow.type]}`}
        </MyLink>
      )}
      {!!availabilityLater?.quantity && (!short || !availabilityNow?.quantity) && (
        <MyLink
          reloaded
          href={'#'}
          onClick={e => onNavigate(e, `${url}#${ElementIdTab.TabAvailabilityRecordOrder}`)}
          className={styles.onOrder}
        >
          {`${quantityLimitation(availabilityLater.quantity)} шт. ${AvailableStringProductRow[availabilityLater.type]}`}
        </MyLink>
      )}
      {!availabilityNow?.quantity &&
        !availabilityLater?.quantity &&
        (allQuantity ? (
          <MyLink reloaded href={url} onClick={e => onNavigate(e, url)} className={styles.onOrder}>
            <span>{allQuantity} шт.</span>
            <span>{AvailableStringByCartProduct[AvailableType.NoInfo]}</span>
          </MyLink>
        ) : (
          AvailableStringByCartProduct[AvailableType.NoInfo]
        ))}
      {(!availabilityNow?.quantity || !availabilityLater?.quantity) && (
        <div className={styles.emptyLine}>{!isMobile && <span>&nbsp;</span>}</div>
      )}
    </div>
  );
};
